import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=26c815bc&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"
import style0 from "./Work.vue?vue&type=style&index=0&id=26c815bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c815bc",
  null
  
)

export default component.exports